import { PAGE_SELECTION_TYPE_STORY_PARENT } from "%/dynamic-components/builder-engine/constants/click-action-constants";

export function resolveContextualPageValue(value) {
  if (value !== PAGE_SELECTION_TYPE_STORY_PARENT) {
    return value;
  }
  const parentId = typeof window !== "undefined" ? window.blclient?.data?.readerStoryParentId : 0;
  return parentId ? `story/${parentId}` : null;
}
